import React from "react";
import { Link } from "react-router-dom";
import Corpo from "../components/Corpo";
import { useWebsocket } from "../hooks/websocket";
import { findCategoryActives } from "../services/category";
import { getUserSession } from "../services/user-service";
import { invitationAvailable } from "./invite";

export default function TabJogo(props) {
  const [categorias, setCategorias] = React.useState([]);
  const { stompClient, connectWebsocket } = useWebsocket();

  const responseInviteCallback = React.useCallback(
    (messageData) => {
      const invitationMessageData = JSON.parse(messageData.body);
      window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));

      if (
        invitationMessageData.challengerId.toString() !==
          window.GLOBALS.user.info.id.toString() &&
        !window.GLOBALS.searchingUser &&
        !window.GLOBALS.isInMultiplayer &&
        !window.GLOBALS.openInvitation
      ) {
        invitationAvailable(invitationMessageData, stompClient);
      }
    },
    [stompClient]
  );

  const joinChallengeCallback = React.useCallback((messageData) => {
    const message = JSON.parse(messageData.body);

    window.GLOBALS.actualMultiplayerMatch.questions = message.questions;
    window.GLOBALS.actualMultiplayerMatch.info = message;
    window.GLOBALS.actualMultiplayerMatch.info.challenger = {
      id: message.challengerId,
      name: message.challengerName,
      matchPoints: message.challengerMatchPoints,
      scoreDebit: 0,
    };
    window.GLOBALS.actualMultiplayerMatch.info.opponent = {
      id: message.userId,
      name: message.name,
      matchPoints: message.opponentMatchPoints,
      scoreDebit: 0,
    };
    window.GLOBALS.actualMultiplayerMatch.info.matchId = message.challengerId
      .toString()
      .concat(message.userId.toString());

    window.GLOBALS.isInMultiplayer = true;

    window.GLOBALS.actualMultiplayerMatch.themeId = message.themeId;
    window.GLOBALS.actualMultiplayerMatch.guestUserId = message.guestUserId;
    window.GLOBALS.actualMultiplayerMatch.challengedUserId = message.challengedUserId;

    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

    window.GLOBAL_HISTORY.push("/tab/desafio/0");
  }, []);

  const subscribes = React.useCallback(() => {
    stompClient.subscribe(
      `/user/${window.GLOBALS.user.info.id.toString()}/queue/invite`,
      responseInviteCallback
    );

    stompClient.subscribe(
      `/user/${window.GLOBALS.user.info.id.toString()}/queue/join-challenge`,
      joinChallengeCallback
    );
  }, [joinChallengeCallback, responseInviteCallback, stompClient]);

  const connectCallback = React.useCallback(
    (frame) => {
      console.log("Conexão Websocket realizada com sucesso!");

      getUserSession().then((res) => {
        stompClient.publish({
          destination: "/app/register-user",
          body: JSON.stringify({
            key: "users",
            userId: res.data.id,
            name: res.data.nome,
          }),
        });
      });

      subscribes();
    },
    [stompClient, subscribes]
  );

  React.useEffect(() => {
    connectWebsocket(connectCallback);
  }, [connectWebsocket, connectCallback]);

  React.useEffect(() => {
    const abortController = new AbortController();

    findCategoryActives().then((res) => {
      setCategorias(res.data);

      if (localStorage.getItem("GLOBALS") != null) {
        window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
        window.GLOBALS.categoriasArray = res.data;
        window.GLOBALS.isInMultiplayer = false;
        window.GLOBALS.searchingUser = false;
        window.GLOBALS.openInvitation = false;
        localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
      }
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);

  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div className="view-jogo tab-selecao-conteudo pane pane-game">
          <div
            className="padding scroll-content ionic-scroll has-tabs-top"
            style={{ top: "56px" }}
          >
            <div className="scroll">
              <h2>Selecione um conteúdo</h2>

              {categorias.map((categoria) => (
                <Link
                  className="button button-full button-lg ng-binding"
                  key={categoria.id}
                  to={"/tab/type/" + categoria.id}
                >
                  {categoria.nome}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
